import React, { memo } from 'react';

import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import useLocales from 'src/hooks/useLocales';

import { UserDataType } from '../../../../../@types/forms/enums/UserDataType';

type ElementUserDataSettingsProps = {
  userInfo: number | null | undefined;
  onUserInfoChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ElementUserDataSettings: React.FC<ElementUserDataSettingsProps> = ({
  userInfo,
  onUserInfoChange,
}) => {
  const { t } = useLocales();

  return (
    <Box>
      <FormControl>
        <FormLabel>{t('forms.elements.settings.userData')}</FormLabel>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={userInfo}
          onChange={onUserInfoChange}
        >
          <FormControlLabel
            value={UserDataType.Name}
            control={<Radio />}
            label={`${t('forms.elements.settings.nameSurname')}`}
            id="nrR6ym"
          />
          <FormControlLabel
            value={UserDataType.Email}
            control={<Radio />}
            label={`${t('forms.elements.settings.emailAddress')}`}
            id="GcgODE"
          />
          <FormControlLabel
            value={UserDataType.Phone}
            control={<Radio />}
            label={`${t('forms.elements.settings.phoneNumber')}`}
            id="5QY11g"
          />
          <FormControlLabel
            value={UserDataType.Company}
            control={<Radio />}
            label={`${t('forms.elements.settings.company')}`}
            id="oXQKZX"
          />
          <FormControlLabel
            value={UserDataType.Job}
            control={<Radio />}
            label={`${t('forms.elements.settings.jobTitle')}`}
            id="qa9wLh"
          />
          <FormControlLabel
            value={UserDataType.Address}
            control={<Radio />}
            label={`${t('forms.elements.settings.address')}`}
            id="1UASlG"
          />
          <FormControlLabel
            value={UserDataType.ManagersName}
            control={<Radio />}
            label={`${t('forms.elements.settings.managersName')}`}
            id="8beGAS"
          />
          <FormControlLabel
            value={UserDataType.ManagersEmail}
            control={<Radio />}
            label={`${t('forms.elements.settings.managersEmail')}`}
            id="fsycom"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default memo(ElementUserDataSettings);
